import Formatter from "@/utils/formatter"
import { i18n } from "@/plugins/i18n"

export default (value, filterFunction) => {
  if (value !== undefined && value !== "") {
    if (filterFunction !== undefined && filterFunction !== null) {
      switch (filterFunction) {
        case "daysFromNow":
          return Formatter().formatDaysFromNow(value)
        case "localeString":
          var localeString = new Date(value)
          return localeString.toLocaleString()
        case "secondsToWholeHours":
          return Number(value / 3600).toFixed(0)
        default:
          return i18n.global.t("common.invalidUsage")
      }
    }
  }

  return ""
}
